import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import sanityClient from "../../sanityClient";

export default function HomeQuote() {
    const [homeQuoteContent, setHomeQuoteContent] = useState(null);

    useEffect(() => {
        sanityClient
            .fetch(`*[_type == "homePageContent"][0].homeQuote1{ description, name }`)
            .then((data) => {
                if (data) setHomeQuoteContent(data);
            })
            .catch(console.error);
    }, []);

    return (
        <section className="home-quote">
            <div className="container">
                <div className="row justify-content-center">
                    <div
                        className="col-lg-7 col-md-10 wow animate__animated animate__slideInUp"
                        data-wow-duration="1s"
                        data-wow-delay="0.1s"
                    >
                        <img
                            src="/assets/home/quote.png"
                            alt="quote"
                            loading="lazy"
                        />
                        {homeQuoteContent ? (
                            <>
                                <h4>{homeQuoteContent.description}</h4>
                                <label>{homeQuoteContent.name}</label>
                            </>
                        ) : (
                            <h4></h4>
                        )}
                        <Link to="/contact-us" className="default-btn">
                            get in-touch<span></span>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
